export const validateRe2Regex = (value = '') => {
  if (!value.trim()) {
    return ''
  }

  try {
    new RegExp(value)
  } catch (error) {
    return error instanceof Error
      ? `Must be a valid regular expression. ${error.message}`
      : 'Must be a valid regular expression'
  }

  return ''
}
